<template>
  <div>
    <div class="container">
      <div class="container-no-top-bottom">
        <div class="columns">
          <div class="column is-2">
            <div>
              <img
                alt="Vue logo"
                src="../../../assets/travessia_logo.png"
                width="220px"
                height="70px"
              >
            </div>
          </div>
          <div class="column is-1 input-margin">
            <label for class="filter-label">Filtro:</label>
          </div>
          <div class="column is-3 input-margin">
            <v-autocomplete
              auto-select-first
              dense
              filled
              rounded
              v-model="filterOne"
              :items="categories"
              item-text="name"
              item-value="id"
              placeholder="Categorias"
            ></v-autocomplete>
          </div>
          <div class="column is-3 input-margin">
          </div>
          <div class="column is-3 input-margin">
            <v-text-field
              dense
              filled
              rounded
              @input="filterPerThemes(search)"
              v-model="search"
              :placeholder="'Pesquise'"
              name="Pesquisar"
            ></v-text-field>
          </div>
        </div>
      </div>
      <section>
        <div class="container-no-top-bottom mt-xs-5 mt-sm-2 mt-md-3 mt-lg-1 mt-xl-1">
          <div class="h3-padding-bottom">
            <h3 class="h3-section">Rascunhos</h3>
          </div>
          <div class="columns is-multiline">
            <t-box
              v-for="essay in essayDraft"
              :key="essay.id"
              :title="essay.title"
              :description="essay.theme"
              class="column is-3"
            >
              <div class="columns is-mobile text-center mt-4">
                <div class="column is-4">
                  <t-button size="sm" color="0f62ab">Enviar</t-button>
                </div>
                <div class="column is-4">
                  <t-button size="sm" color="success">Editar</t-button>
                </div>
                <div class="column is-4">
                  <t-button size="sm" color="danger">Excluir</t-button>
                </div>
              </div>
            </t-box>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import TButton from '@/components/TButton.vue'
import TBox from '@/components/TBox.vue'
import EssayService from '@/services/essay/essay'
import CategoryService from '@/services/category/category'
import InstitutionService from '@/services/institution/Institution'

export default {
  name: 'EssayDraft',
  components: {
    TButton,
    TBox
  },
  data () {
    return {
      valueWidthBox: 294,
      filterOne: 'TODAS AS INSTITUIÇÕES',
      filterOnePattern: 0,
      categoriesImmutable: [],
      categories: [],
      institutions: [],
      categoriesFilteredByInstitutions: [],
      categoriesFilteredByThemes: [],
      search: '',
      CategoryService: new CategoryService(),
      InstitutionService: new InstitutionService(),
      essayDraft: [],
      filterTwo: 'PERÍODO',
      EssayService: new EssayService()
    }
  },
  mounted () {
    this.loadCategoryThemes()
    this.loadInstitutions()
    this.getDrafts()
  },
  methods: {
    loadCategoryThemes () {
      this.CategoryService.listCategory()
        .then(result => {
          this.categoriesImmutable = result.data.data
          this.categories = this.copyArray(this.categoriesImmutable)
          console.log(this.categories)
        })
        .catch(err => {
          console.log(err)
        })
    },
    loadInstitutions () {
      this.InstitutionService.list()
        .then(result => {
          this.institutions = this.prepareInstitutions(result.data.data)
        })
        .catch(err => {
          console.log(err)
        })
    },
    prepareInstitutions (institutions) {
      const institutionCustom = []
      institutions.forEach(institution => {
        institutionCustom.push({
          label: institution.name,
          value: institution.id
        })
      })
      institutionCustom.push({ label: 'TODAS AS INSTITUIÇÕES', value: 0 })
      return institutionCustom
    },
    filterPerInstitutions (selectedInstitution) {
      if (this.search === '') {
        this.categories =
        selectedInstitution.value === this.filterOnePattern
          ? this.copyArray(this.categoriesImmutable)
          : this.filterPerInstitutionsCategoryThemes(
            this.categoriesImmutable,
            selectedInstitution
          )
      } else {
        this.categories =
        selectedInstitution.value === this.filterOnePattern
          ? this.copyArray(this.categoriesFilteredByThemes)
          : this.filterPerInstitutionsCategoryThemes(
            this.categoriesFilteredByThemes,
            selectedInstitution
          )
      }

      this.categoriesFilteredByInstitutions = this.copyArray(this.categories)
    },
    filterPerInstitutionsCategoryThemes (categories, selectedInstitution) {
      let categoriesFilter = this.copyArray(categories)
      categoriesFilter = categoriesFilter.map(category => {
        category.themes = category.themes.filter(theme => {
          return theme.institution_id === selectedInstitution.value
        })
        return category
      })
      return categoriesFilter
    },
    filterPerThemes (search) {
      if (this.filterOne.value === this.filterOnePattern || this.filterOne === 'TODAS AS INSTITUIÇÕES') {
        this.categories =
        search === ''
          ? this.copyArray(this.categoriesImmutable)
          : this.filterPerThemeSpecific(this.categoriesImmutable, search)
      } else {
        this.categories =
        search === ''
          ? this.copyArray(this.categoriesImmutable)
          : this.filterPerThemeSpecific(this.categoriesFilteredByInstitutions, search)
      }
      this.categoriesFilteredByThemes = this.copyArray(this.categories)
    },
    filterPerThemeSpecific (categories, search) {
      let categoriesFilter = this.copyArray(categories)
      categoriesFilter = categoriesFilter.map(category => {
        category.themes = category.themes.filter(theme => {
          return theme.title.indexOf(search) !== -1
        })
        return category
      })
      return categoriesFilter
    },
    goToEssayWriter (themeId) {
      this.$router.push({ path: `redacao/${themeId}` })
    },
    copyArray (array) {
      return JSON.parse(JSON.stringify(array))
    },
    async getDrafts () {
      try {
        const { data } = await this.EssayService.listEssayDrafts()
        this.essayDraft = data.data
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style scoped>
.container-background {
  height: 100%;
}

.filter-label {
  font-size: 25px;
  font-weight: 600;
}

.h3-section {
  font-size: 25px;
  font-weight: 600;
}
/* BOX */
.h3-padding-bottom {
  padding-bottom: 1rem;
}
.input-margin {
  margin-top: 1em;
}
@media screen and (min-width: 320px) and (max-width: 768px) {
  .input-margin {
    margin-top: 0;
  }
}
</style>
